document.addEventListener('DOMContentLoaded', function() {
  const loginForm = document.querySelector('.auth-login');
  const registerForm = document.querySelector('.auth-register');
  const forgotForm = document.querySelector('.auth-forgot');

  function showForm(formToShow) {
    document.querySelectorAll('.auth-form').forEach(form => {
      form.classList.remove('active');
    });
    formToShow.classList.add('active');
  }

  document.querySelectorAll('.switch-to-register').forEach(btn => {
    btn.addEventListener('click', () => showForm(registerForm));
  });

  document.querySelectorAll('.switch-to-login').forEach(btn => {
    btn.addEventListener('click', () => showForm(loginForm));
  });

  document.querySelectorAll('.switch-to-forgot').forEach(btn => {
    btn.addEventListener('click', () => showForm(forgotForm));
  });
}); 